import { Nullable } from 'cng-common/models/utils'

interface ICalculateDiffPPParams {
  sobActual: Nullable<number>
  sobPlan: Nullable<number>
}

export const calculateDiffPP = ({ sobActual, sobPlan }: ICalculateDiffPPParams) => {
  if (!sobActual || !sobPlan) {
    return null
  }

  return sobActual - sobPlan
}
